var app = angular.module('filters');

app.filter('capitalize', capitalize);


function capitalize () {
	return function (input) {
		return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/filters/capitalize.filter.js
 ** module id = 243
 ** module chunks = 1
 **/